import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  whatsappMessage = 'Classroom Pilot स्कूल सॉफ्टवेअरबद्दल सविस्तर माहिती हवी आहे.';

  get whatsappLink(): string {
    return 'https://wa.me/919767605767?text=' + encodeURIComponent(this.whatsappMessage);
  }

}

